
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {DOWNLOAD_INVOICE} from '@/store/action-types'
import {Invoice} from '@/model/Invoice'

@Component({
  components: {
    // PayBySquare
  }
})
export default class InvoiceDetailTab extends Vue {
  @Prop({type: Object}) invoice!: Invoice

  @Action(DOWNLOAD_INVOICE) downloadInvoice!: ({ (invoice: Invoice): Promise<void> })

  private downloadInProgress: boolean = false
  private showDownloadFailedSnackBar: boolean = false

  async onDownloadInvoiceButtonClick(): Promise<void> {
    if (this.invoice) {
      this.downloadInProgress = true

      try {
        await this.downloadInvoice(this.invoice)
      } catch (e) {
        this.showDownloadFailedSnackBar = true
      } finally {
        this.downloadInProgress = false
      }
    }
  }
}

